import React from 'react'
import { Controller, FieldValues, UseFormReturn, RegisterOptions } from 'react-hook-form'
import NumberFormat from 'react-number-format'
import InputField from '../../../../components/common/inputs/InputField'

interface Props {
  formControl: UseFormReturn<FieldValues>
  name: string
  label: string | Array<string | HTMLElement>
  infoTip?: string
  rules?: RegisterOptions
  disabled?: boolean
  defaultValue?: string
  endAdornment?: string
  decimalScale?: number
}

const NumberField: React.FC<Props> = ({
  formControl,
  name,
  label,
  infoTip,
  rules,
  disabled,
  defaultValue,
  endAdornment,
  decimalScale,
}) => {
  return (
    <Controller
      name={name}
      control={formControl.control}
      rules={rules}
      defaultValue={defaultValue}
      render={({ field }) => (
        <NumberFormat
          errorMessage={formControl.formState.errors[name]?.message?.toString()}
          decimalScale={decimalScale || 0}
          allowNegative={false}
          customInput={InputField}
          endAdornment={endAdornment}
          id={name}
          getInputRef={field.ref}
          label={label}
          infoTip={infoTip}
          disabled={disabled}
          isNumericString={true}
          {...field}
        />
      )}
    />
  )
}

export default NumberField
